/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskIdRelatedOrgTxblPartnership
 */
export interface ExecRiskIdRelatedOrgTxblPartnership {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    RelatedOrganizationName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    EIN?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    PrimaryActivitiesTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    LegalDomicileStateCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    LegalDomicileForeignCountryCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    DirectControllingNACd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    PredominantIncomeTypeTxt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    ShareOfTotalIncomeAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    ShareOfEOYAssetsAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    DisproportionateAllocationsInd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    UBICodeVAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    GeneralOrManagingPartnerInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedOrgTxblPartnership
     */
    OwnershipPct?: string;
}

/**
 * Check if a given object implements the ExecRiskIdRelatedOrgTxblPartnership interface.
 */
export function instanceOfExecRiskIdRelatedOrgTxblPartnership(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskIdRelatedOrgTxblPartnershipFromJSON(json: any): ExecRiskIdRelatedOrgTxblPartnership {
    return ExecRiskIdRelatedOrgTxblPartnershipFromJSONTyped(json, false);
}

export function ExecRiskIdRelatedOrgTxblPartnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskIdRelatedOrgTxblPartnership {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'RelatedOrganizationName': !exists(json, 'RelatedOrganizationName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['RelatedOrganizationName']),
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
        'EIN': !exists(json, 'EIN') ? undefined : json['EIN'],
        'PrimaryActivitiesTxt': !exists(json, 'PrimaryActivitiesTxt') ? undefined : json['PrimaryActivitiesTxt'],
        'LegalDomicileStateCd': !exists(json, 'LegalDomicileStateCd') ? undefined : json['LegalDomicileStateCd'],
        'LegalDomicileForeignCountryCd': !exists(json, 'LegalDomicileForeignCountryCd') ? undefined : json['LegalDomicileForeignCountryCd'],
        'DirectControllingNACd': !exists(json, 'DirectControllingNACd') ? undefined : json['DirectControllingNACd'],
        'PredominantIncomeTypeTxt': !exists(json, 'PredominantIncomeTypeTxt') ? undefined : json['PredominantIncomeTypeTxt'],
        'ShareOfTotalIncomeAmt': !exists(json, 'ShareOfTotalIncomeAmt') ? undefined : json['ShareOfTotalIncomeAmt'],
        'ShareOfEOYAssetsAmt': !exists(json, 'ShareOfEOYAssetsAmt') ? undefined : json['ShareOfEOYAssetsAmt'],
        'DisproportionateAllocationsInd': !exists(json, 'DisproportionateAllocationsInd') ? undefined : json['DisproportionateAllocationsInd'],
        'UBICodeVAmt': !exists(json, 'UBICodeVAmt') ? undefined : json['UBICodeVAmt'],
        'GeneralOrManagingPartnerInd': !exists(json, 'GeneralOrManagingPartnerInd') ? undefined : json['GeneralOrManagingPartnerInd'],
        'OwnershipPct': !exists(json, 'OwnershipPct') ? undefined : json['OwnershipPct'],
    };
}

export function ExecRiskIdRelatedOrgTxblPartnershipToJSON(value?: ExecRiskIdRelatedOrgTxblPartnership | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RelatedOrganizationName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.RelatedOrganizationName),
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
        'EIN': value.EIN,
        'PrimaryActivitiesTxt': value.PrimaryActivitiesTxt,
        'LegalDomicileStateCd': value.LegalDomicileStateCd,
        'LegalDomicileForeignCountryCd': value.LegalDomicileForeignCountryCd,
        'DirectControllingNACd': value.DirectControllingNACd,
        'PredominantIncomeTypeTxt': value.PredominantIncomeTypeTxt,
        'ShareOfTotalIncomeAmt': value.ShareOfTotalIncomeAmt,
        'ShareOfEOYAssetsAmt': value.ShareOfEOYAssetsAmt,
        'DisproportionateAllocationsInd': value.DisproportionateAllocationsInd,
        'UBICodeVAmt': value.UBICodeVAmt,
        'GeneralOrManagingPartnerInd': value.GeneralOrManagingPartnerInd,
        'OwnershipPct': value.OwnershipPct,
    };
}

